import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { isDealRentCianAgency } from './isDealRentCianAgency';

export const agentName: TComputedPropMapper<string | undefined> = (props, ctx) => {
  const { user, isByHomeowner } = props.offer;
  const { masterAgent, cianUserId, agencyName } = user || {};
  if (isDealRentCianAgency(props, ctx)) {
    return 'Эксклюзивно от Циан';
  }

  if (isByHomeowner) {
    return 'Собственник';
  }

  if (masterAgent && masterAgent.name) {
    return masterAgent.name;
  }

  if (agencyName) {
    return agencyName;
  }

  if (cianUserId) {
    return `ID ${cianUserId}`;
  }

  return undefined;
};
